/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Grid } from '@mui/material';
import { DialogForm, IDialogActions, ISnackbarAlert, SelectField, SnackbarAlert, TextFieldInput, TextFieldReadOnly } from '../../../shared/components';
import { GenericService } from '../../../shared/services';
import { LocalStorange } from '../../../shared/environment';
import { AssistantDTO, AssistantFilterDTO } from '../../../shared/interfaces';
import { useTranslation } from 'react-i18next';

interface IAssistantMaintenanceProps {
    setActionExecuted: (value: boolean) => void;
}

export const AssistantMaintenance: React.FC<IAssistantMaintenanceProps> = ({ setActionExecuted }) => {
    const [assistantList, setAssistantList] = useState<AssistantDTO[]>([]);
    const [assistantDTO, setAssistantDTO] = useState<AssistantDTO | undefined>(undefined);
    const [loading, setLoading] = useState(false);
    const [snackBarAlert, setSnackBarAlert] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenMessage] = useState(false);
    const [isOpenDialog, setIsOpenDialog] = useState(false);
    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');
    const { t } = useTranslation();

    useEffect(() => {
        handleGetAssistantList();
    }, []);

    const handleGetAssistantList = useCallback(async () => {
        const assistantFilterDTO = {
            // Adicione filtros se necessário
        };
        GenericService.GetAllAsync1('assistant', assistantFilterDTO, setLoading, setAssistantList, showMessage);
    }, []);

    const handleSelectAssistant = useCallback((id: string) => {
        const selectedAssistant = assistantList.find(assistant => assistant.id === id);
        setAssistantDTO(selectedAssistant ? { ...selectedAssistant } : undefined);
    }, [assistantList]);

    const handleSaveClick = useCallback(async () => {
        const dto = assistantDTO as AssistantDTO;

        if (dto.id === '' || dto.id === undefined) {
            dto.createdById = userInfo.user.id;
            GenericService.AddAsync1('assistant', dto, setAssistantDTO, setActionExecuted, setLoading, showMessage);
        } else {
            dto.updatedById = userInfo.user.id;
            GenericService.UpdateAsync1('assistant', dto, setActionExecuted, setLoading, showMessage);
        }

        // Recarregar a lista de assistentes após salvar
        handleGetAssistantList();
        setIsOpenDialog(false);
    }, [assistantDTO, handleGetAssistantList]);

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarAlert(msg);
        setIsOpenMessage(true);
    }

    const actions: IDialogActions[] = [
        { id: 'save', text: t('assistant.maintenanceButton.save'), icon: 'save_outlined', iconColor: 'primary', setAction: handleSaveClick },
        { id: 'close', text: t('assistant.maintenanceButton.close'), icon: 'close_outlined', iconColor: 'secondary', setAction: () => setIsOpenDialog(false) },
    ];

    return (
        <React.Fragment>
            <Button variant="contained" color="primary" onClick={() => setIsOpenDialog(true)}>
                {t('assistant.maintenanceButton.openDialog')}
            </Button>
            {isOpenMessage && (
                <SnackbarAlert
                    snackBarAlert={snackBarAlert}
                    setIsOpen={setIsOpenMessage}
                    isOpen={isOpenMessage}
                />
            )}
            <DialogForm
                title={t('assistant.detailsName')}
                icon='group_outlined'
                setIsOpen={setIsOpenDialog}
                isOpen={isOpenDialog}
                fullWidth={true}
                maxWidth={'lg'}
                actions={actions}
                loading={loading}
            >
                <React.Fragment>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <SelectField
                                id='assistantSelect'
                                label={t('assistant.maintenance.selectAssistant')}
                                value={assistantDTO?.id || ''}
                                setValue={(id) => handleSelectAssistant(id)}
                                valueList={assistantList}
                                required={true}
                                labelKey='name' // Use a propriedade que representa o nome do assistente
                                valueKey='id'
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextFieldInput
                                id='name'
                                label={t('assistant.maintenance.name')}
                                value={assistantDTO?.name}
                                setValue={setAssistantDTO}
                                obj={assistantDTO}
                                required={true}
                                maxLength={200}
                                autoFocus={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextFieldInput
                                id='description'
                                label={t('assistant.maintenance.description')}
                                value={assistantDTO?.description}
                                setValue={setAssistantDTO}
                                obj={assistantDTO}
                                multiline={true}
                                rows={2}
                            />
                        </Grid>
                        {assistantDTO?.id && (
                            <Grid item xs={12} md={4}>
                                <TextFieldReadOnly
                                    id={'id'}
                                    label={t('assistant.maintenance.id')}
                                    value={assistantDTO.id}
                                    hasDivider={false}
                                    hasToolTip={true}
                                />
                            </Grid>
                        )}
                    </Grid>
                </React.Fragment>
            </DialogForm>
        </React.Fragment>
    );
};
